import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/services/api/api.service';
import {
  CaseFeature,
  CaseFeatureFilters,
} from './interfaces/case-feauture.interfaces';

@Injectable({
  providedIn: 'root',
})
export class CaseFeatureService {
  constructor(private readonly apiService: ApiService) {}

  create(data: CaseFeature) {
    return this.apiService.post<{ success: boolean; item: CaseFeature }>(
      'case-features/create',
      data
    );
  }

  update(data: CaseFeature) {
    return this.apiService.patch<{ success: boolean; item: CaseFeature }>(
      'case-features/update',
      data
    );
  }

  getAll(filter: CaseFeatureFilters) {
    return this.apiService.post<{ success: boolean; items: CaseFeature[] }>(
      'case-features/get-all',
      filter
    );
  }

  isFeatureUsed(featureId: number) {
    return this.apiService.get<{
      success: true;
      response: boolean;
    }>(`case-features/is-feature-used/${featureId}`);
  }
}
